var _path, _path2, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "circleInfoTitle"
  }, "Information Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "circleInfoTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,0C10.8,0,0,10.8,0,24s10.8,24,24,24s24-10.8,24-24S37.2,0,24,0 M24,46C11.9,46,2,36.1,2,24S11.9,2,24,2 c12.1,0,22,9.9,22,22S36.1,46,24,46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S22.9,16,24,16"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "25,20 20,20 20,22 23,22 23,34 20,34 20,36 28,36 28,34 25,34 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIIcon);
export default __webpack_public_path__ + "static/media/info-i-icon.ddd3ccb458ee15ca04e1a61e3708d1df.svg";
export { ForwardRef as ReactComponent };